module.exports = __webpack_public_path__ + "img/testimonials-4.08d8679b.jpg";